<template>
    <div class="title-box">
        <span class="title" v-html="text"></span>
    </div>
</template>
<script>
    export default {
        name: 'Title',
        props: {
            text: {
                type: String,
                required: true
            },
        },
    }
</script>
<style lang="scss" scoped>
    .title-box{
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        text-align: left;
        background: url("./img/bg.png");
        background-size: 100% 100%;
        padding: 0 16px;
        .title{
            color: #222;
            font-weight: 600;
            font-size: 17px;
            position: relative;
        }
    }
</style>
